import {
  LabelType,
  type ParticipantBehaviour,
  type ParticipantEmbeddableForm,
} from '@piccolohealth/pbs-common';
import React from 'react';

import { FormStack } from '../../components/forms/FormStack';
import { HookedFormField } from '../../components/forms/HookedFormField';
import { HookedInput } from '../../components/forms/HookedInput';
import { HookedLabelChooser } from '../../components/forms/HookedLabelChooser';
import { HookedMultiSelect } from '../../components/forms/HookedMultiSelect';
import { HookedSelect } from '../../components/forms/HookedSelect';
import { ParticipantQRBehavioursControl } from './ParticipantQRBehavioursControl';
import { participantQRStatusOptions } from './ParticipantQRStatusTag';

interface Props {
  participantBehaviours: ParticipantBehaviour[];
  participantEmbeddableForms: ParticipantEmbeddableForm[];
}

export const ParticipantQRForm = (props: Props) => {
  const { participantBehaviours, participantEmbeddableForms } = props;

  const embeddableFormOptions = participantEmbeddableForms.map((embeddableForm) => {
    return {
      value: embeddableForm.id,
      label: embeddableForm.name,
      raw: embeddableForm,
    };
  });

  return (
    <FormStack>
      <HookedFormField name='name' label='Name'>
        <HookedInput name='name' size='sm' placeholder='Enter a name' noNulls />
      </HookedFormField>

      <HookedFormField name='status' label='Status'>
        <HookedSelect
          name='status'
          size='sm'
          placeholder='Choose a status'
          optionVariant='tag'
          options={Object.values(participantQRStatusOptions)}
        />
      </HookedFormField>

      <HookedFormField name='behaviours' label='Behaviours'>
        <ParticipantQRBehavioursControl participantBehaviours={participantBehaviours} />
      </HookedFormField>

      <HookedFormField name='embeddableFormIds' label='Forms'>
        <HookedMultiSelect
          name='embeddableFormIds'
          size='sm'
          placeholder='Add a form'
          optionVariant='tag'
          options={embeddableFormOptions}
        />
      </HookedFormField>

      <HookedFormField name='labelIds' label='Labels'>
        <HookedLabelChooser name='labelIds' type={LabelType.ParticipantQr} />
      </HookedFormField>
    </FormStack>
  );
};
